import React from "react";

// services
import LearningContentService from "services/LearningContentService";

import { toast } from "react-toastify";

import { injectIntl, defineMessages } from "react-intl";
import Translations from "../content.json";
import DataDisplay from "../../../components/DataDisplayView/DataDisplay.js";

const messages = defineMessages(Translations);

const INITIAL_STATE = {
  open: false,
  isLoading: false,
  action: "",
  baselineList: [],
  alert: null,
  openassignClassDialog: false,
  btnDisabled: false
};

class BaselineOffline extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ...INITIAL_STATE,
      direction: localStorage.getItem("direction"),
      language: localStorage.getItem("language"),
      baselineList: [],
      baselineListWithoutFilter: [],
      page: 0,
      rowsPerPage: 10,
      rowsPerPageOptions: [10, 25, 50]
    };
  }

  componentDidMount() {
    this.getBaselineData();
  }

  getBaselineData = _ => {
    this.setState({ open: false, isLoading: true });
    LearningContentService.fetchAllBaselineOfflineData()
      .then(response => {
        if (response && parseInt(response._statusCode) === 200)
          response._entity &&
            this.setState({
              baselineList: response._entity,
              baselineListWithoutFilter: response._entity
            });
        else throw response;
      })
      .then(_ => this.setState({ isLoading: false }))
      .catch(error => {
        const {
          intl: { formatMessage }
        } = this.props;
        let errorMessage = "";
        if (error && error._message) errorMessage = error._message;
        else errorMessage = formatMessage(messages.teachers.errorMessageText);
        this.setState(
          {
            isLoading: false,
            fetchData: false
          },
          () => {
            toast.error(errorMessage);
          }
        );
      });
  };

  onSearch = e => {
    const { baselineListWithoutFilter } = this.state;
    const value = e.target.value.toLowerCase();
    const filteredData = baselineListWithoutFilter.filter(
      x =>
        (x._assessmentContentId &&
          x._assessmentContentId.toLowerCase().indexOf(value) !== -1) ||
        (x._gradeName && x._gradeName.toLowerCase().indexOf(value) !== -1)
    );
    this.setState({ baselineList: filteredData });
  };

  render() {
    const { isLoading, baselineList } = this.state;

    //Default List
    let tbContentList = [];
    if (typeof baselineList !== "undefined" && baselineList.length > 0) {
      tbContentList = baselineList.map(item => {
        const {
          _assessmentContentId,
          _gradeName,
          _assessmentQuestionDtos
        } = item;
        return [
          _assessmentContentId,
          _gradeName,
          _assessmentQuestionDtos &&
            _assessmentQuestionDtos.map(item => {
              return <p>{item._contentId}</p>;
            })
        ];
      });
    }

    return (
      <DataDisplay
        tableHead={[
          "Assessment Content Id",
          "Grade Name",
          "Assessment Questions"
        ]}
        tableData={tbContentList}
        search={this.onSearch}
        searchPlaceHolderText="Search Baseline"
        cardIconTitle="Lessons"
        isLoading={isLoading}
        uploadButtonText="Upload Baseline Offline Data"
        uploadPath="/baseline-offline/bulk-upload"
        colspan={4}
        customClassesForCells={[3]}
        customHeadClassesForCells={[3]}
      />
    );
  }
}

export default injectIntl(BaselineOffline);
